import { ProspectorListItem } from './types';

export const targetMarketList = [
  {
    count: 560000,
    title: 'Addressable Market',
    to: '/prospector/list/addressable-market',
  },
  {
    count: 120000,
    title: 'B2B Tech US',
    to: '/prospector/list/b2b-tech-us',
  },
  {
    count: 180000,
    title: 'B2B Tech EMEA',
    to: '/prospector/list/b2b-tech-emea',
  },
  {
    count: 120000,
    title: 'MM+ Worldwide',
    to: '/prospector/list/mm-worldwide',
  },
  {
    count: 16000,
    title: 'Companies visiting website',
    to: '/prospector/list/companies-visiting-website',
  },
] as ProspectorListItem[];

export const recentProspectsList = [
  {
    title: 'Deal Maker Prospects',
    to: '/prospector/list/deal-maker-prospects',
  },
] as ProspectorListItem[];

export const savedProspectsList = [
  {
    title: 'Deal Maker Prospects',
    to: '/prospector/list/deal-maker-prospects',
  },
  {
    title: 'Morgan Prospects',
    to: '/prospector/list/morgan-prospects',
  },
  {
    title: 'MM+ Prospects',
    to: '/prospector/list/mm-prospects',
  },
  {
    title: 'US-based Developers',
    to: '/prospector/list/us-developers',
  },
  {
    title: 'Buyers @ Visiting Companies',
    to: '/prospector/list/buyers-visiting-companies',
  },
] as ProspectorListItem[];

const mockSegments = [
  {
    title: 'Segment 1',
    count: 100000,
  },
  {
    title: 'Segment 2',
    count: 90000,
  },
  {
    title: 'Segment 3',
    count: 100000,
  },
  {
    title: 'Segment 4',
    count: 60000,
  },
  {
    title: 'Segment 5',
    count: 50000,
  },
] as ProspectorListItem[];

export const collections = [
  { title: 'Collection 1', segments: mockSegments },
  { title: 'Collection 2', segments: mockSegments },
  { title: 'Collection 3', segments: mockSegments },
  { title: 'Collection 4', segments: mockSegments },
  { title: 'Collection 5', segments: mockSegments },
  { title: 'Collection 6', segments: mockSegments },
  { title: 'Collection 7', segments: mockSegments },
  { title: 'Collection 8', segments: mockSegments },
  { title: 'Collection 9', segments: mockSegments },
  { title: 'Collection 10', segments: mockSegments },
  { title: 'Collection 11', segments: mockSegments },
  { title: 'Collection 12', segments: mockSegments },
];
